import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';

export function ErrorNotification({
  title = 'Error',
  text,
  close,
  align = 'center',
}) {
  const styles = style(align);

  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.title}>{title}</Text>
        <Text style={styles.text}>{text}</Text>
      </View>
      <Pressable onPress={() => close()} style={styles.closeIconContainer}>
        <Text style={styles.closeButton}>Dismiss</Text>
      </Pressable>
    </View>
  );
}

const style = (align) => {
  const containerPosition =
    align === 'bottom'
      ? {
          position: 'sticky',
          bottom: 20,
          width: '100%',
        }
      : {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: [{ translateX: '-50%' }, { translateY: '-50%' }],
          width: '60%',
        };

  return StyleSheet.create({
    // @ts-ignore
    container: {
      ...containerPosition,
      backgroundColor: '#ffd2d2',
      zIndex: 9999,
      padding: 10,
      borderRadius: 10,
      display: 'flex',
      shadowRadius: 20,
      shadowOpacity: 0.5,
      shadowOffset: { width: 0, height: 5 },
    },
    textContainer: {
      display: 'flex',
      flex: 1,
      marginBottom: 10,
    },
    title: {
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: 5,
    },
    text: {
      fontSize: 16,
    },
    closeIconContainer: {
      display: 'flex',
      alignItems: 'flex-end',
    },
    closeButton: {
      fontWeight: 'bold',
    },
  });
};
